// extracted by mini-css-extract-plugin
var _1 = "OverviewAttentionReason-moduleOverviewAttentionReason__R0oS7";
var _2 = "OverviewAttentionReason-modulereason__IOOR4";
export { _1 as "OverviewAttentionReason", _2 as "reason" }
